import React from "react";
/* Import Boostrap */
import Heading3 from '../titles/Heading3';
import FeaturesAccordionQuestions from './featuresaccordion-item';


function FeaturesAccordion(props) {
    const items = props.content;
    const itemsDetails = items.map(( item, index ) =>
        // Key should be specified inside the array.
        <span  key={ index.toString() }>
            <Heading3 title={ item.title }/>
            <FeaturesAccordionQuestions value={ item }/>
        </span>
    );
    return (
        <div>
            { itemsDetails }
        </div>
    );
}

export default class FeaturesAccordionSection extends React.Component {
    render() {
        return (
            <FeaturesAccordion content={ this.props.content }/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/featuresaccordion.jsx